import { getPersonDataById } from '../../persons/mockData'
import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { ILeadSourceContact } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'

const leadSourceContactListData = undefined as unknown as ILeadSourceContact[]

export const getLeadSourceContactListData = getListDataFunctionFactory<
  ILeadSourceContact[]
>({
  listData: leadSourceContactListData,
  storageKey: 'leadsourcecontacts',
  getStartingListData: getStartingLeadSourceContactListData,
})

export async function getLeadSourceContactDataById(
  id: TEntityId
): Promise<ILeadSourceContact> {
  const list: ILeadSourceContact[] = await getLeadSourceContactListData()
  if (!list) {
    throw new Error(`getLeadSourceContactListData returned undefined/null`)
  }
  const lsc = list.find((leadSourceContact) => leadSourceContact.id === id)
  if (!lsc) {
    throw new Error(`Can't find leadSourceContact '${id}'`)
  }
  return lsc
}

export async function getLeadSourceContactDataByDescr(
  descr: string
): Promise<ILeadSourceContact> {
  const list: ILeadSourceContact[] = await getLeadSourceContactListData()
  if (!list) {
    throw new Error(`getLeadSourceContactListData returned undefined/null`)
  }
  const lsc = list.find(
    (leadSourceContact) => leadSourceContact.descr === descr
  )
  if (!lsc) {
    throw new Error(`Can't find leadSourceContact '${descr}'`)
  }
  return lsc
}

export async function getStartingLeadSourceContactListData(): Promise<
  ILeadSourceContact[]
> {
  return [
    {
      id: 'XXLSO0001',
      hrid: 'LSO0001',
      leadSource: {},
      person: await getPersonDataById('XXPE0019'),
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: false,
    },
  ]
}
